import React from 'react';
import './LevelAnchor.css';
import { StringUtilService } from '../../../../../shared/src/services/util/string-util.service';

export const LevelAnchor = ({
    levelData,
    setElementToScroll,
}) => {
    const anchor = StringUtilService.stringToKebabCase(levelData.description);
    const anchorHref = `#${anchor}`;

    const onClickHandler = () => {
        setElementToScroll(anchorHref);
    };

    const anchorStyles = {
        backgroundColor: levelData.colors.main,
    };

    return <div
        onClick={onClickHandler}
        className="loyalty-level-anchors__item loyalty-level-anchor"
        style={anchorStyles}
    >
        <span className="loyalty-level-anchor__title">{levelData.description}</span>
        <img className="loyalty-level-anchor__main-icon" src={levelData.images.level} alt=""/>
        <img className="loyalty-level-anchor__progress-icon" src={levelData.images.progress} alt=""/>
    </div>;
};
